<ng-container *transloco="let t; read: 'user'">
<div class="p-5">
  <drdp-title [title]=title></drdp-title>

  <drdp-container>
    <drdp-container color="lightBlue" additionClasses="p-6">
      <form class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-2" [formGroup]="searchForm" (ngSubmit)="handleExport()">
        <div class="col-span-1 md:col-span-3 lg:col-span-5">
          <mat-checkbox color="primary" formControlName="isGlobalAgencies"></mat-checkbox>
          <label class="inline">{{ t('stateDashboard.search.applyToAllAgencies') }}</label>
        </div>

        <drdp-select-state [initialStateId]="stateId.value" [required]="true" [disabled]="true"></drdp-select-state>

        @if (!isGlobalAgencies.value) {
          <drdp-select-agency #agencySelect [stateId]="stateId.value" [initialAgencyId]="agencyId.value" [omitTestAgencies]="true"
            (agency)="handleDropdown($event, selectType.Agencies)" [required]="true" [clear]="clearDropdowns">
          </drdp-select-agency>
        }

        @if (displayDropdowns.ageGroup) {
          <drdp-select-age-grade #ageGroupInstrumentSelect [stateId]="stateId.value" [label]="t('stateDashboard.search.ageGroup')" [multiSelect]="false"
            (ageGrade)="handleDropdown($event, selectType.AgeInstrument)" [required]="requiredFields.ageGroup" [clear]="clearDropdowns"
            [schoolYearId]="schoolYearId">
          </drdp-select-age-grade>
        }

        @if (displayDropdowns.enrollmentProgram) {
          <drdp-select-program-type [ageGradeId]="ageGroupId.value" [label]="t('stateDashboard.search.programName')" [multiSelect]="true" [distinct]="distinctPrograms"
            (programType)="handleDropdown($event, selectType.EnrollmentProgram)" [required]="requiredFields.enrollmentProgram" [clear]="clearDropdowns">
          </drdp-select-program-type>
        }

        @if (displayDropdowns.homeLanguage) {
          <drdp-select-language #homeLanguageSelect [label]="t('stateDashboard.search.homeLanguage')" [required]="requiredFields.homeLanguage"
          [multiSelect]="true" (language)="handleDropdown($event, selectType.Language)"></drdp-select-language>
        }

        @if (displayDropdowns.schoolYear) {
           <drdp-select-school-year [label]="t('stateDashboard.search.schoolYear')" [disabled]="true" [currentSchoolYear]="true"></drdp-select-school-year>
        }

        @if (displayDropdowns.globalRatingPeriods) {
          <drdp-select-global-rating (ratingPeriod)="handleDropdown($event, selectType.GlobalRatingPeriods)" [multiSelect]="true"
            [required]="requiredFields.globalRatingPeriods" [label]="t('stateDashboard.search.ratingPeriod')"
            [clear]="clearDropdowns" [showAll]="false" [hideFromStateDash]="true">
          </drdp-select-global-rating>
        }

        @if (displayDropdowns.disability) {
          <drdp-select-disability #disabilitySelect [label]="t('stateDashboard.search.primaryDisability')" [required]="requiredFields.disability"
          [multiSelect]="true" (disability)="handleDropdown($event, selectType.PrimaryDisability)"></drdp-select-disability>
        }

        @if (displayDropdowns.siteLevelCounty) {
          <drdp-select-county (county)="handleDropdown($event, selectType.County)" [stateId]="stateId.value" [multiSelect]="true"
            [multiSelectInitVals]="true" [clear]="clearDropdowns" [label]="t('stateDashboard.search.siteLevelCounty')">
          </drdp-select-county>
        }

        <div class="flex items-end justify-end mt-4 md:mt-0 md:col-start-3 lg:col-start-5">
          <drdp-btn type="submit" [disabled]="searchForm.invalid">{{downloadBtnText}}</drdp-btn>
          <drdp-btn class="ml-2" type="button" (click)="clear()">{{ t('stateDashboard.search.clear') }}</drdp-btn>
        </div>
      </form>
    </drdp-container>
  </drdp-container>
</div>
</ng-container>